module.exports = __webpack_public_path__ + "img/hue-saturation-3.e1dce677.webp";